import { useQuery } from '@tanstack/react-query'

import { transferServices } from '../transferServices'
import { EstimateSavingTransferOutFeePayload } from '../transferTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useGetEstimateSavingTransferOutFee = (
  payload: EstimateSavingTransferOutFeePayload,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.SAVINGS_GOAL_TRANSFER_DETAILS, payload],
    queryFn: () => transferServices.estimateSavingTransferOutFee(payload),
    staleTime: 60 * 5 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
    enabled: payload.amount > 0, // Only fetch when amount is valid
  })
